<script>
import 'vue-select/dist/vue-select.css'
import { axiosGetPost } from '@router/axiosGetPost'

export default {
  name: 'DuplicateLog',
  props: {
    requestId: [Number, String],
    type: String,
  },
  data() {
    return {
      request_id: this.requestId,
      options: [],
      search: null,
      duplicates: [],
      requestFromDp: null,
      loandingDataDpM: false,
      url: {
        request_base: null,
        massive_duplicate: null,
      },
    }
  },
  created() {
    this.request_id = this.requestId
    //console.log(this.type)
    //console.log(this.requestId)
    if (this.type === 'FCL') {
      this.url.request_base = 'requests/searchSelectRL'
      this.url.massive_duplicate = 'contracts/massive_duplicate'
    } else {
      this.url.request_base = 'requestsLCL/searchSelectRL'
      this.url.massive_duplicate = 'contractsLcl/massive_duplicate'
    }
    this.searchInit()
  },
  methods: {
    onSearch(search, loading) {
      loading(true)
      // this.search(loading, search, this)
      this.fetchData(search)
      loading(false)
    },
    searchInit() {
      let searchIdLocal = this.request_id
      if (searchIdLocal !== null || searchIdLocal !== '0') {
        this.fetchData(searchIdLocal)
        this.requestFromDp = searchIdLocal
        this.loadDuplicates()
      }
    },
    fetchData(search) {
      this.duplicates = []
      this.options = []
      axiosGetPost('post', this.url.request_base, {
        request_id: search,
      }).then((data) => {
        // console.log(data)
        if (data.success) {
          this.options = data.data
        } else {
        }
        return data
      })
    },
    loadDuplicates() {
      axiosGetPost('put', this.url.request_base, {
        request_id: this.requestFromDp,
      }).then((data) => {
        // console.log(data)
        if (data.success) {
          this.duplicates = data.data
        } else {
        }
        return data
      })
    },
    massivelyDuplicate(id) {
      this.$swal({
        title: 'Deseas duplicar masivamente \n el request ' + id + ' ?',
        text: 'El proceso Duplicara la informacion a cada contracto anidado',
        type: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        confirmButtonText: 'Si!',
        cancelButtonText: 'No',
      }).then((result) => {
        if (result.value) {
          this.loandingDataDpM = true
          // llamar al metodo que carga la data y habilitar this.tableLoaded = true una vez terminado
          axiosGetPost('post', this.url.massive_duplicate, {
            request_id: id,
          }).then((data) => {
            // console.log(data)
            this.requestStatus = data.data
            this.loandingDataDpM = false
            this.$swal('OK')
            // this.$root.$emit(this.emit, ToD)
            return data
          })
          //this.loandingDataDpM = false
        } else {
          this.$swal('Cancelled')
        }
      })
    },
  },
}
</script>

<template>
  <div>
    <div
      v-if="loandingDataDpM"
      class="row align-items-center justify-content-center"
      style="height: 300px"
    >
      <div class="col-12 col-md-8 text-center">
        <b-spinner
          label="Loading..."
          variant="secondary"
          class="ml-3"
        ></b-spinner>
      </div>
    </div>
    <div v-else>
      <div class="form-group row">
        <div class="col-md-6">
          <h4 class="header-title mt-2 mb-1">
            <i class="uil uil-files-landscapes"></i> Request ID: From
            <span style="color: green">{{ requestFromDp }} </span>
          </h4>
        </div>
        <div class="col-md-3"></div>
        <div class="col-md-3">
          <b-button
            variant="danger"
            class="mt-0"
            @click="massivelyDuplicate(requestFromDp)"
            >
            Massively Duplicate
          </b-button>
        </div>
      </div>
      <!-- <hr /> -->
      <div class="form-group row">
        <div class="col-lg-2"></div>
        <div class="col-lg-8">
          <label for="default">Request ID</label>
          <v-select
            v-model="requestFromDp"
            label="name"
            :filterable="false"
            :reduce="(options) => options.id"
            :options="options"
            @search="onSearch"
            @input="loadDuplicates"
          >
            <template slot="no-options"> Type to search... </template>
          </v-select>
        </div>
        <div class="col-lg-1 mt-2">
          <br />
        </div>
      </div>
      <div class="form-group row">
        <div class="col-md-12">
          <div v-if="duplicates.length >= 1">
            <div class="table-responsive">
              <table class="table table-sm mb-0">
                <thead>
                  <tr>
                    <th scope="col">Request ID</th>
                    <th scope="col">Base ID</th>
                    <th scope="col">Company User</th>
                    <th scope="col">R. Name</th>
                    <th scope="col">Status</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(row, r) in duplicates" :key="r">
                    <th scope="row">{{ row.id }}</th>
                    <td>{{ row.base }}</td>
                    <td>{{ row.company_user }}</td>
                    <td>{{ row.name }}%</td>
                    <td>{{ row.status }}</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>